// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"310":"1b4a9bd8","453":"75908a64","539":"ad442d80","957":"a477a8c9"}[chunkId] + ".chunk.js";
};